import { Attr, IndexedMesh } from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


type TriAttrs = {
    normal: Attr,
    uv: Attr;
}

type ThreePairs = [
    x1: number, y1: number,
    x2: number, y2: number,
    x3: number, y3: number,
];

export class Triangle extends IndexedMeshWriter<TriAttrs> {

    verts: ThreePairs;

    constructor(...verts: ThreePairs) {
        super();
        this.verts = verts;
    }

    computeAttributeCounts(): IndexedMesh<TriAttrs> {
        const mesh = new IndexedMesh({
            normal: new Attr(3),
            uv: new Attr(2),
        });

        mesh.index.count = 3;
        mesh.position.count = 3;
        mesh.attrs.normal.count = 3;
        mesh.attrs.uv.count = 3;

        return mesh;
    }

    computeMeshData(mesh: IndexedMesh<TriAttrs>) {
        const
            [ x1, y1, x2, y2, x3, y3 ] = this.verts,
            idx = mesh.index.data,
            pos = mesh.position.data,
            norm = mesh.attrs.normal.data,
            uv = mesh.attrs.uv.data;

        idx[0] = 0; idx[1] = 1; idx[2] = 2;

        pos[0] = x1; pos[1] = y1; // pos[2] = z = 0
        pos[3] = x2; pos[4] = y2; // pos[5] = z = 0
        pos[6] = x3; pos[7] = y3; // pos[8] = z = 0

        norm[0] = 0; norm[1]  = 0; norm[2]  = 1;
        norm[3] = 0; norm[4]  = 0; norm[5]  = 1;
        norm[6] = 0; norm[7]  = 0; norm[8]  = 1;

        uv[0] = pos[0]; uv[1] = pos[1];
        uv[2] = pos[3]; uv[3] = pos[4];
        uv[4] = pos[6]; uv[5] = pos[7];
    }
};
